import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './NormalDonationCard.css'
import { generateDynamicCSS } from '../../ComponentsMap';
import { createDonationCardInstance } from '../../Models/DonationCard';
import { Link } from 'react-router-dom';
const NormalDonationCard = (props) => {
    const shouldAnimate = props.animation && props.animation.animationType && props.animation.animationType !== 'none';

    return (
        <Link to={`/campaigns/${props.name}?id=${props.id}`} className={`nav-link col-lg-4 col-md-6 col-12 p-2 `}>
            <Card 
                className={`p-2 Pointer DonationCard ${props.className} NormalDonationCard ${props.display === "overlayed" ? "overlayed" : "normal"}`} 
                key={props.id}
                {...(shouldAnimate ? {
                    'data-aos': props.animation.animationType,
                    'data-aos-duration': Number(props.animation.animationDuration),
                    'data-aos-delay': Number(props.animation.animationDelay),
                } : {})}
            >
                <div className="DonationCardImageContainer NormalDonationCardImageContainer">
                    <Card.Img variant="top" src={props.mainImage} />
                </div>
                <Card.Body className='text-center pb-5 NormalDonationCardText DonationCardBody'>
                    <Card.Title>{props.name}</Card.Title>
                    <Card.Text>
                        {props.description.substring(0, 90)+"..."}     
                    </Card.Text>
                </Card.Body>
            </Card>
        </Link>
    );
};

export default NormalDonationCard;